// extracted by mini-css-extract-plugin
module.exports = {"cookieNotificationHolder":"MobileCookieNotification_cookieNotificationHolder__2I6V-","linkWrapper":"MobileCookieNotification_linkWrapper__1554c"};